import React from 'react';
import { Stack, Box, Button, Theme } from '@mui/material';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';
import {
  EVideoMenuItem,
  VideoFooterMenuOption,
  VideoFooterMenuOptionChild,
} from 'shared/types/video.interface';

interface VideoFooterMenuProps {
  isOpen: boolean;
  onClose: () => void;
  menuOptions: VideoFooterMenuOption[];
  onMenuItemClick: (key: string) => void;
}

const VideoFooterMenu: React.FC<VideoFooterMenuProps> = ({
  isOpen,
  onClose,
  menuOptions,
  onMenuItemClick,
}) => {
  if (!menuOptions.length) return null;

  return (
    <Stack
      sx={{
        position: 'absolute',
        bottom: 'calc(100% + 5px)',
        right: '10px',
        width: 'max-content',
        borderRadius: '8px',
        backgroundColor: 'primary.contrastText',
        boxShadow: (theme: Theme) => `0 2px 24px 0 ${theme.palette.myShadow.menu}`,
        zIndex: 5,
      }}
    >
      {isOpen &&
        menuOptions &&
        menuOptions.length &&
        menuOptions.map((option: VideoFooterMenuOption, index: number) => (
          <Stack key={index}>
            <Button
              variant="menu"
              onClick={() => {
                if (option.type !== EVideoMenuItem.group) onMenuItemClick(`${option.key}`);
                onClose();
              }}
              disableRipple
            >
              <Box component="span">{option.label}</Box>
              {option.isActive && <DoneRoundedIcon sx={{ fontSize: '15px' }} />}
            </Button>
            {option.children &&
              option.children.length &&
              option.children.map((child: VideoFooterMenuOptionChild, i: number) => (
                <Button
                  key={i}
                  variant="menu"
                  onClick={() => {
                    onMenuItemClick(`${option.key}|${child.deviceId}`);
                    onClose();
                  }}
                  sx={{ pl: '27px' }}
                  disableRipple
                >
                  <Box component="span">{child.label}</Box>
                  {option.activeOption === child.deviceId && (
                    <DoneRoundedIcon sx={{ fontSize: '15px' }} />
                  )}
                </Button>
              ))}
          </Stack>
        ))}
    </Stack>
  );
};

export default VideoFooterMenu;
